/* eslint-disable semi */
import codes from './type_mapping_codes';

// ----------------------------------------------------------------------------
// コード定義一覧から選択要素を自動生成
// ----------------------------------------------------------------------------
const singleSelects = {};
const multipleSelects = {};
const radioGroups = {};
const checkboxGroups = {};
const singleDynamicSelects = {};
const labels = {};

/**
 * スキーマで定義された型.クラスと入力コンポーネントとの関連付の定義
 */
const mapping = {
  'string': ['app-input-text', { 'clearable': false, 'class': 'medium' }],
  'string.label.noborder': ['app-label', { 'readonly': true, 'border': false }],
  'string.label': ['app-input-text', { 'readonly': true, 'class': 'long', 'border': true }],

  'string.like': ['app-input-text', { 'clearable': false, 'class': 'medium', 'suffix': 'を含む' }],
  'string.start_with': ['app-input-text', { 'clearable': false, 'class': 'medium', 'suffix': 'で始まる' }],
  'string.end_with': ['app-input-text', { 'clearable': false, 'class': 'medium', 'suffix': 'で終わる' }],

  'string.mini': ['app-input-text', { 'clearable': false, 'class': 'mini' }],
  'string.short': ['app-input-text', { 'clearable': false, 'class': 'short' }],
  'string.medium': ['app-input-text', { 'clearable': false, 'class': 'medium' }],
  'string.long': ['app-input-text', { 'clearable': false, 'class': 'long' }],
  'string.full': ['app-input-text', { 'clearable': false, 'class': 'full' }],

  'string.han': ['app-code', {'clearable': false, 'class': 'medium'}],
  'string.han20': ['app-code', {'clearable': false, 'class': 'medium', 'maxLength': 20}],

  'string.tel': ['app-code', {'clearable': false, 'class': 'medium', 'maxLength': 20}],
  'string.email': ['app-code', {'clearable': false, 'class': 'long', 'maxLength': 80}],
  'string.zipcode': ['app-zip-code', {'clearable': false, 'class': 'short'}],

  'string.zen20': ['app-zen', { 'clearable': false, 'class': 'long', 'maxLength': 20 }],
  'string.zen30': ['app-zen', { 'clearable': false, 'class': 'long', 'maxLength': 30 }],
  'string.zen32': ['app-zen', { 'clearable': false, 'class': 'long', 'maxLength': 32 }],
  'string.zen35': ['app-zen', { 'clearable': false, 'class': 'long', 'maxLength': 35 }],
  'string.zen40': ['app-zen', { 'clearable': false, 'class': 'long', 'maxLength': 40 }],

  'string.kana': ['app-kana', { 'clearable': false, 'class': 'long' }],
  'string.kana20': ['app-kana', { 'clearable': false, 'class': 'long', 'maxLength': 20 }],
  'string.kana35': ['app-kana', { 'clearable': false, 'class': 'long', 'maxLength': 35 }],
  'string.kana40': ['app-kana', { 'clearable': false, 'class': 'long', 'maxLength': 40 }],

  'string.password': ['app-input-password', { 'clearable': false, 'class': 'long' }],

  'string.textarea': ['app-input-textarea', {'clearable': false, 'class': 'long'}],
  'string.textarea-full': ['app-input-textarea', {'clearable': false, 'class': 'full'}],

  'string.code3': ['app-code', {'clearable': false, 'class': 'app-code03', 'maxLength': 3}],
  'string.code4': ['app-code', {'clearable': false, 'class': 'app-code05', 'maxLength': 4}],

  // 前ゼロコード値
  'string.code02': ['app-code', {'clearable': false, 'class': 'app-code02', 'padding0': 2}],
  'string.code03': ['app-code', {'clearable': false, 'class': 'app-code03', 'padding0': 3}],
  'string.code05': ['app-code', {'clearable': false, 'class': 'app-code05', 'padding0': 5}],
  'string.code06': ['app-code', {'clearable': false, 'class': 'app-code06', 'padding0': 6}],
  'string.code08': ['app-code', {'clearable': false, 'class': 'app-code08', 'padding0': 8}],

  // コード値
  // 'string.code': ['app-code', {'clearable': false, 'class': 'short'}],

  // 数値
  'number': ['app-input-number', { 'clearable': false, 'class': 'short' }],
  'number.mini': ['app-input-number', { 'clearable': false, 'class': 'mini' }],
  'number.label.noborder': ['app-label-number', { 'border': false }],
  'number.label': ['app-label-number', { 'border': true, 'class': 'short' }],

  // 日付・時間
  'string.month': ['app-input-month'],
  'string.date': ['app-input-date'],
  'string.datetime': ['app-input-date-time'],
  'string.time': ['app-input-time'],

  'number.flg-checkbox': ['app-checkbox'], // 1:チェック有 0:チェック無 trueLabel/falseLabelで指定可能
  'string.flg-checkbox': ['app-checkbox', {'trueLabel': '1', 'falseLabel': '0'}],

  // デフォルト定義
  'default': ['app-input-none']
}

Object.assign(mapping, multipleSelects);
Object.assign(mapping, singleSelects);
Object.assign(mapping, radioGroups);
Object.assign(mapping, checkboxGroups);
Object.assign(mapping, singleDynamicSelects);
Object.assign(mapping, labels);
Object.assign(mapping, codes);

export default mapping



// WEBPACK FOOTER //
// ./src/app/parts/type_mapping.js